import LoggingService from 'client/util/LoggingService';

/**
 * This service is meant to coordinate which Router should be responsible at any given time.
 */

function getLocationHashPath() {
  return window.location.hash.replace('#', '');
}

export function createGlobalRouteService(_getLocationHashPath = getLocationHashPath) {
  let vueRouter;
  let renderBackboneApp;
  let routeHandler;
  let onUpdateRoute;
  let onUpdateRouteMetadata;

  // On the first load the Vue App completes before globalRouteService is initialized
  let renderBackboneAppOnInitialized = false;

  const state = {
    appHandlingRoute: 'backbone',
    initialized: false,
    backboneRendered: false,
  };

  function isVueRoute(path = _getLocationHashPath()) {
    return vueRouter.getMatchedComponents(path).length > 0;
  }

  return {
    // Initialize router and store to avoid circular dependencies.
    initialize: (options) => {
      ({ vueRouter, renderBackboneApp } = options);
      state.initialized = true;
      if (renderBackboneAppOnInitialized) {
        renderBackboneApp();
      }
    },
    getState: () => ({ ...state }),
    passToVue: () => {
      LoggingService.debug('globalRouteService.passToVue');
      state.appHandlingRoute = 'vue';
    },
    passToBackbone: () => {
      LoggingService.debug('globalRouteService.passToBackbone');
      state.appHandlingRoute = 'backbone';
    },
    isVueHandlingRoute: () => state.appHandlingRoute === 'vue',
    isBackboneHandlingRoute: () => state.appHandlingRoute === 'backbone',
    isVueRoute,
    registerRouteHandler: (handler) => { routeHandler = handler; },
    resolveRoute: (value = true) => {
      LoggingService.debug('globalRouteService.resolveRoute: ', { value, routeHandler });
      if (typeof routerHandler === 'function') {
        routeHandler(value);
      }
    },
    cleanUpBackboneApp: () => {
      LoggingService.debug('globalRouteService.cleanUpBackboneApp');
      if (window.viewport) {
        window.viewport.closeAside();
        window.viewport.renderBlankPanel();
      }
    },
    renderBackboneApp: () => {
      if (!state.backboneRendered) {
        if (!state.initialized) {
          renderBackboneAppOnInitialized = true;
          return;
        }
        renderBackboneApp();
      }
      state.backboneRendered = true;
    },
    kickBackboneApp: () => {
      LoggingService.debug('globalRouteService.kickBackboneApp');
      if (Backbone.History.started) Backbone.history.stop();
      Backbone.history.start();
    },
    triggerVueNavigation: () => {
      LoggingService.debug('globalRouteService.triggerVueNavigation', () => {});
      // Push the current location to re-trigger Vue Router's lifecycle
      vueRouter.push(_getLocationHashPath());
    },
    onUpdateRoute: (handler) => { onUpdateRoute = handler; },
    updateRoute: () => {
      LoggingService.debug('globalRouteService.updateRoute');
      if (typeof onUpdateRoute === 'function') {
        onUpdateRoute(_getLocationHashPath());
      }
    },
    onUpdateRouteMetadata: (handler) => { onUpdateRouteMetadata = handler; },
    updateRouteMetadata: (metadata) => {
      LoggingService.debug('globalRouteService.updateRouteMetadata');
      if (typeof onUpdateRouteMetadata === 'function') {
        onUpdateRouteMetadata(metadata);
      }
    },
  };
}

export default createGlobalRouteService();
